import React from 'react';

export function NotChecked () {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
      >
          <rect
            width="19"
            height="19"
            x="0.5"
            y="0.5"
            stroke="#919191"
            rx="3.5"
          />
      </svg>
    );
}
